// extracted by mini-css-extract-plugin
export default {"main":"StudentOverview_main__Ke9WA","button":"StudentOverview_button__lmKk+"};